export default __webpack_public_path__ + "media/Seasoning-Oil.416406c6.png";